import { useToast } from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { AdvanceRatesRoute } from './AdvanceRateRoute';
import { errorToastConfig } from 'packages/common-frontend/constants';
import { useDataMetadataContext } from 'valleyBank/domains/page/hooks/DataMetadataContext';
import { useUserRoleTypePermissionsContext } from 'valleyBank/domains/page/hooks/useUserRoleTypePermissions';
import { ValleyBankTemplate } from 'valleyBank/domains/page/ui/ValleyBankTemplate';

export const AdvanceRateRouter = () => {
  const { dashboardMode } = useDataMetadataContext();
  const { permissions } = useUserRoleTypePermissionsContext();
  const navigate = useNavigate();
  const toast = useToast();

  if (dashboardMode === 'historical') {
    toast({
      ...errorToastConfig,
      id: 'advance-rate-only-current-mode',
      title: 'Advance Rates only available in "current" or "preview" mode.',
    });
    navigate('/');
  }

  if (!permissions.advanceRateRead) {
    toast({
      ...errorToastConfig,
      id: 'unauthorized-advance-rate',
      title: 'Your user role does not allow access to Advance Rates',
    });
    navigate('/');
  }

  return (
    <ValleyBankTemplate>
      <AdvanceRatesRoute />
    </ValleyBankTemplate>
  );
};
